import { twMerge } from 'tailwind-merge'
import { clsx, type ClassValue } from 'clsx'

export const getQueryString = (
  params: URLSearchParams,
  key: string,
  value: string,
) => {
  const current = new URLSearchParams(Array.from(params.entries()))

  if (!value || value === "false" || value === '') {
    current.delete(key)
  } else {
    current.set(key, value)
  }

  const search = current.toString()
  const query = search ? `?${search}` : ''

  return query
}

export function isValidUrl(url: string) {
  try {
    // eslint-disable-next-line no-new
    new URL(url)
    return true
  } catch (e) {
    return false
  }
}

export function getUrlFromString(str: string) {
  if (isValidUrl(str)) return str
  try {
    if (str.includes('.') && !str.includes(' ')) {
      return new URL(`https://${str}`).toString()
    }
  } catch (e) {
    return null
  }
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const removeDashAndCapitalize = (str: string) => {
  return str.replace(/-/g, ' ').replace(/\b\w/g, (l: string) => l.toUpperCase())
}
